import AppRoutes from "./Routes";
import "./styles/custom.css";  

function App() {
  return (
    <>
      <AppRoutes />
    </>
  );
}

export default App;
